const jsonSchema = [
  {
    type: 'group',
    fields: [
      {
        name: 'firstName',
        label: 'First Name',
        type: 'text',
        required: true,
        showInList: true
      },
      {
        name: 'lastName',
        label: 'Last Name',
        type: 'text',
        required: true,
        showInList: true
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'email',
        label: 'Email',
        type: 'text',
        required: true,
        showInList: true
      },
      {
        name: 'personalMobile',
        label: 'Phone',
        type: 'text',
        required: true,
        showInList: true
      },
      {
        name: 'dob',
        label: 'Date of Birth',
        type: 'date',
        required: true,
        showInList: true
      }
    ]
  },
  {
    name: 'avatar',
    label: 'Avatar',
    type: 'fileUploader',
    required: false,
    showInList: false
  }

  // Add more fields as needed
];
export default jsonSchema;
